import { JWEInvalid } from '../util/errors.js';
export default function checkP2s(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) {
        throw new JWEInvalid('PBES2 Salt Input must be 8 or more octets');
    }
}



// WEBPACK FOOTER //
// ./~/jose/dist/browser/lib/check_p2s.js